<button mat-raised-button color="primary" (click)="loginWithRedirect()">
    Sign Up
</button>  
